import { render, staticRenderFns } from "./playerProfileTopInformation.vue?vue&type=template&id=63ace8a4&scoped=true"
import script from "./playerProfileTopInformation.vue?vue&type=script&lang=js"
export * from "./playerProfileTopInformation.vue?vue&type=script&lang=js"
import style0 from "./playerProfileTopInformation.vue?vue&type=style&index=0&id=63ace8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ace8a4",
  null
  
)

export default component.exports